import { render, staticRenderFns } from "./columnsContent.vue?vue&type=template&id=0255b392&scoped=true&"
import script from "./columnsContent.vue?vue&type=script&lang=js&"
export * from "./columnsContent.vue?vue&type=script&lang=js&"
import style0 from "./columnsContent.vue?vue&type=style&index=0&id=0255b392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0255b392",
  null
  
)

export default component.exports